module.exports = __webpack_public_path__ + "img/ro.c5098543.svg";